export default "__VITE_ASSET__BJhxo$og__"